module.exports = __webpack_public_path__ + "static/media/home_hero.62c8999f.svg";